import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansSignUpComponent from './loansSignUp.component';

import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

import loansSignUpForm from './loansSignUpForm/loansSignUpForm';
import loansSignUpFormSimulation from './loansSignUpFormSimulation/loansSignUpFormSimulation';
import loansSignUpModal from './loansSignUpModal/loansSignUpModal';
import loansSignUpConfirmationModal from './loansSignUpConfirmationModal/loansSignUpConfirmationModal';
import loansMandatoryInsuranceModal from './loansMandatoryInsuranceModal/loansMandatoryInsuranceModal';
import loansSignUpService from './loansSignUp.service';
import loansSignUpResume from './loansSignUpResume/loansSignUpResume';

let loansSignUpModule = angular.module('loansSignUp', [
  uiRouter,
  loansSignUpForm,
  loansSignUpFormSimulation,
  loansSignUpModal,
  loansSignUpConfirmationModal,
  loansMandatoryInsuranceModal,
  loansSignUpResume,
])

  .component('loansSignUp', loansSignUpComponent)

  .config(($stateProvider) => {
    'ngInject';
    $stateProvider
      .state(STATES.LOANS.SIGN_UP, {
        url: ROUTES.LOANS.SIGN_UP,
        component: 'loansSignUp',
        params: {
          snapshot: null,
          from: null,
          originalFrom: null,
          hardReset: null
        },
        data: {
          requiresAuth: true,
        },
        resolve: {
          /* @ngInject */
          serviceClosed: (StatusAppCheckers) => StatusAppCheckers.isServiceClosed(),
        },
      });
  })

  .service('loansSignUpService', loansSignUpService)

  .name;

export default loansSignUpModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUp.js